import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '复工复产、出行证明、证件办理……疫情期间的业务办理，你想知道的都在这！';

const route: RouteConfig = {
  path: '/20200303ZBBYQ',
  name: 'LHYZ',
  component: () => import('./Home.vue'),
  // redirect: '/2019FMXY/Welcome',
  meta: {
    title: PAGE_TITLE,
  },
};

export default route;
